import _, { isNumber } from 'lodash'

import { dashedOutOrWithPrecision, PolicyGioValueRow } from './policy-value-row'
import MESSAGES from 'core/data-model/constants/bi-messages'
import CONSTANTS from 'core/data-model/constants/messages'
import VALUES from 'core/data-model/constants/values'
import { getSubtotalNonGuaranteeDividend } from 'core/service/pdf-generation/products/term-life/sections/policy-value-table-example-section'
import { formatNumber } from 'core/service/lib/number-format'
import Mustache from 'mustache'
import { WordWraps } from 'common-components'

const getRateWording = (rate) => {
  switch (rate) {
    case -1:
      return MESSAGES.GLOBAL_INDEX_16_6_BENEFITS_SCENARIO_LOW
    case 3:
      return MESSAGES.GLOBAL_INDEX_16_6_BENEFITS_SCENARIO_MIDDLE
    case 5:
      return MESSAGES.GLOBAL_INDEX_16_6_BENEFITS_SCENARIO_HIGH
    default:
      return MESSAGES.GLOBAL_INDEX_16_6_BENEFITS_SCENARIO_HIGH
  }
}

const getExample = (rate) => {
  switch (rate) {
    case -1:
      return MESSAGES.EXAMPLE_1
    case 3:
      return MESSAGES.EXAMPLE_2
    case 5:
      return MESSAGES.EXAMPLE_3
    default:
      return MESSAGES.EXAMPLE_1
  }
}

const PolicyValueGioTable = (props) => {
  return (
    <div className="policy group" id="policy-value">
      {[-1, 3, 5].map((rate, index) => {
        const getIRR = (rate) => {
          if (rate === -1) {
            return props.policyValue.lowIRR
          } else if (rate === 3) {
            return props.policyValue.mediumIRR
          } else {
            return props.policyValue.highIRR
          }
        }
        return (
          <div id={`policy-value-${index + 1}`} className="example" style={{ marginBottom: '30px' }}>
            <h3 className="name">
              <span className="example-name">{getExample(rate)}</span> {MESSAGES.GLOBAL_INDEX_16_6_BENEFITS_SCENARIO_2}
              {MESSAGES.GLOBAL_INDEX_16_6_BENEFITS_SCENARIO_3} {getRateWording(rate)}
            </h3>
            <div style={{ paddingBottom: '10px' }}>
              {Mustache.render(MESSAGES.INDEX_LINKED_IRR_DESC_1, { IRR: getIRR(rate) })}
            </div>
            {renderNotePolicyValueTableForGio(props, rate, index)}
          </div>
        )
      })}
    </div>
  )
}

const PolicyTable = ({ className, children }) => (
  <table
    className={`policy-table${className ? ` ${className}` : ''}`}
    id="policy-value-table"
    style={{ width: '1400px' }}
  >
    {children}
  </table>
)

const getBreakWord = (word, breakWord) => {
  return (
    <>
      {word.slice(0, word.indexOf(breakWord))}
      <br />
      {word.slice(word.indexOf(breakWord))}
    </>
  )
}

export const PolicyGio = ({
  yearEndPolicyValues,
  lastYearEndPolicy,
  subtotalAnnualBasicPremium,
  subtotalCashDrop,
  subtotalLowSavingCashDrop,
  rate,
  subtotalLowSumDividend,
  subtotalMediumSumDividend,
  subtotalHighSumDividend,
  subtotalLowSumSavingDividend,
  subtotalMediumSumSavingDividend,
  subtotalHighSumSavingDividend,
}) => {
  const getSubtotalDividend = (rate) => {
    if (rate === -1) {
      return [subtotalLowSumDividend, subtotalLowSumSavingDividend]
    } else if (rate === 3) {
      return [subtotalMediumSumDividend, subtotalMediumSumSavingDividend]
    } else if (rate === 5) {
      return [subtotalHighSumDividend, subtotalHighSumSavingDividend]
    }
    return [0, 0]
  }
  const [subtotalSumDividend, subtotalSumSavingDividend] = getSubtotalDividend(rate)
  return (
    <PolicyTable className="with-cash-drop">
      <thead>
        <tr>
          <td rowSpan={2} width="5%">
            {CONSTANTS.AGE}
          </td>
          <td rowSpan={2} className="nowrap" width="7%">
            {MESSAGES.GIO_END_OF_POLICY}
          </td>
          <td colSpan={2}>
            <div>{MESSAGES.BASIC_PREMIUM}</div>
          </td>
          <td colSpan={2} width="14%">
            {getBreakWord(
              MESSAGES.GLOBAL_INDEX_16_6_GUARANTEE_CASHDROP.replace(
                new RegExp(`\\(${MESSAGES.END_OF_YEAR_POLICY_WITH_BRACKET}\\)`, 'g'),
                ''
              ),
              'และ'
            )}
            <br />
            {MESSAGES.END_OF_YEAR_POLICY_WITH_BRACKET}
          </td>
          <td colSpan={2} width="14%">
            {MESSAGES.INDEX_LINKED_BENEFIT}
            <sup>(4)</sup>
            <br />
            {MESSAGES.END_OF_YEAR_POLICY_WITH_BRACKET}
          </td>
          <td colSpan={2} width="13%">
            {getBreakWord(MESSAGES.IN_CASE_DEATH_COVERAGE_END_OF_POLICY, '(')}
          </td>
          <td colSpan={2} width="15%">
            {MESSAGES.IN_CASE_SURRENDER_VALUE_END_OF_POLICY.replace(
              new RegExp(`\\(${MESSAGES.END_OF_YEAR_POLICY_WITH_BRACKET}\\)`, 'g'),
              ''
            ).trim()}
            <br />
            {MESSAGES.END_OF_YEAR_POLICY_WITH_BRACKET}
          </td>
        </tr>
        <tr>
          <td width="10%">ต่อปี</td>
          <td width="10%">สะสม</td>
          <td width="10%">{getBreakWord(MESSAGES.INCASE_OF_CASH_BACK, 'จ่าย')}</td>
          <td width="10%">
            {getBreakWord(MESSAGES.GLOBAL_INDEX_16_6_INCASE_OF_CUMULATIVE_1, 'บริษัท')}
            {getBreakWord(MESSAGES.GLOBAL_INDEX_16_6_INCASE_OF_CUMULATIVE_2, '0.5')}
          </td>
          <td width="10%">
            {MESSAGES.IN_CASE_INDEX_LINKED_BENEFIT}
            <sup>(4.1),(4.2)</sup>
          </td>
          <td width="10%">
            {getBreakWord(MESSAGES.GLOBAL_INDEX_16_6_INCASE_OF_CUMULATIVE_1, 'บริษัท')}
            {getBreakWord(MESSAGES.GLOBAL_INDEX_16_6_INCASE_OF_CUMULATIVE_2, '0.5')}
          </td>
          <td width="10%">
            {getBreakWord(MESSAGES.GLOBAL_INDEX_16_6_DEATH_BENEFIT_GUARANTEE, 'กรณี')}
            <br />
            {MESSAGES.GLOBAL_INDEX_16_6_GUARANTEE}
          </td>
          <td width="10%">
            {MESSAGES.GLOBAL_INDEX_16_6_DEATH_BENEFIT_NON_GUARANTEE.split('\n').map((line, index) => (
              <React.Fragment key={index}>
                {line}
                {index < 2 && <br />}
              </React.Fragment>
            ))}
            <sup>(4),(4.3)</sup>
            <br />
            (ถ้ามี)
          </td>
          <td width="12%">
            {getBreakWord(MESSAGES.POLICY_VALUE_TABLE_CASH_SURRENDER_VALUE_NORIDER, 'กรม')}
            <sup>(2),(3)</sup>
            <br />
            {MESSAGES.GLOBAL_INDEX_16_6_GUARANTEE}
          </td>
          <td width="12%">
            {getBreakWord(MESSAGES.POLICY_VALUE_TABLE_CASH_SURRENDER_VALUE_NORIDER, 'กรม')}
            <br />
            {MESSAGES.INCLUDE_DIVIDEND}
            <sup>(4),(4.4)</sup>
            <br />
            (ถ้ามี)
          </td>
        </tr>
      </thead>
      <tbody>
        {yearEndPolicyValues.map((policyValue) => {
          const dividendValue = policyValue?.dividend?.dividendValue.find((value) => value.title === rate.toString())
          const getValuesByRate = (rate) => {
            if (rate === -1) {
              return [
                policyValue.lowDividend,
                policyValue.lowSavingDividend,
                policyValue.lowDeathBenefitPlusDividend,
                policyValue.lowSurrenderCashPlusDividend,
              ]
            } else if (rate === 3) {
              return [
                policyValue.mediumDividend,
                policyValue.mediumSavingDividend,
                policyValue.mediumDeathBenefitPlusDividend,
                policyValue.mediumSurrenderCashPlusDividend,
              ]
            } else if (rate === 5) {
              return [
                policyValue.highDividend,
                policyValue.highSavingDividend,
                policyValue.highDeathBenefitPlusDividend,
                policyValue.highSurrenderCashPlusDividend,
              ]
            }
            return [0, 0, 0, 0]
          }
          const [dividend, savingDividend, deathBenefitPlusDividend, surrenderCashPlusDividend] = getValuesByRate(rate)
          return (
            <PolicyGioValueRow
              key={`policy-value-row-${policyValue.age.value}`}
              age={policyValue.age}
              yearEndPolicy={policyValue.yearEndPolicy}
              annualBasicPremium={policyValue.annualBasicPremium}
              cumulativeBasicPremium={policyValue.cumulativeBasicPremium}
              cashDrop={policyValue.cashDrop}
              lowSavingCashDrop={policyValue.lowSavingCashDrop}
              deathBenefit={policyValue.deathBenefit}
              deathBenefitPlusNonGuaranteeDividend={dividendValue?.deathBenefitPlusNonGuaranteeDividend}
              surrenderCash={policyValue.surrenderCash}
              surrenderCashPlusNonGuaranteeDividendSurrender={
                dividendValue?.surrenderCashPlusNonGuaranteeDividendSurrender
              }
              dividend={dividend}
              savingDividend={savingDividend}
              deathBenefitPlusDividend={deathBenefitPlusDividend}
              surrenderCashPlusDividend={surrenderCashPlusDividend}
            />
          )
        })}
        <tr
          className="total"
          id={`policy-value-row-${lastYearEndPolicy}`}
          key={`policy-value-row-${lastYearEndPolicy}`}
        >
          <td colSpan={2} className={'td-total'}>
            {MESSAGES.FUND_RISK_TOTAL}
          </td>
          <td>{dashedOutOrWithPrecision(subtotalAnnualBasicPremium, 2)}</td>
          <td>{dashedOutOrWithPrecision(subtotalAnnualBasicPremium, 2)}</td>
          <td>{dashedOutOrWithPrecision(subtotalCashDrop, 2)}</td>
          <td>{dashedOutOrWithPrecision(subtotalLowSavingCashDrop, 2)}</td>
          <td>{dashedOutOrWithPrecision(subtotalSumDividend, 2)}</td>
          <td>{dashedOutOrWithPrecision(subtotalSumSavingDividend, 2)}</td>
          <td colSpan={4} style={{ background: '#f5f5f5' }} />
        </tr>
      </tbody>
    </PolicyTable>
  )
}

export const PolicyValueContent = ({ basicPlan, ...props }) => {
  return <PolicyGio {...props} />
}

const fraction = (top, bottom, decimalPlaces = 0) => (
  <span
    style={{
      display: 'inline-block',
      textAlign: 'center',
      margin: '0 0.1em',
      verticalAlign: 'middle',
    }}
  >
    <span
      style={{
        display: 'block',
        borderBottom: '1px solid black',
        padding: '0 0.2em',
        marginBottom: '-0.2em',
      }}
      class="numerator"
    >
      {decimalPlaces > 0 ? formatNumber(top, decimalPlaces, true) : top}
    </span>
    <span style={{ display: 'block', marginTop: '0.1em' }}>{bottom}</span>
  </span>
)

const dataForDividendTable_1 = [
  ['10', 'ร้อยละ 5'],
  ['15', 'ร้อยละ 10'],
  ['20', 'ร้อยละ 15'],
]

const dataForDividendTable_2_25_5 = [
  ['1', 'ร้อยละ 0'],
  ['2-10', 'ร้อยละ 100'],
  ['11-15', 'ร้อยละ 95'],
  ['16-20', 'ร้อยละ 85'],
  ['21-25', 'ร้อยละ 70'],
]

const dataForDividendTable_2_15_8 = [
  ['1', 'ร้อยละ 0'],
  ['2-10', 'ร้อยละ 100'],
  ['11-15', 'ร้อยละ 70'],
]

const dataForDividendTable_3_25_5 = [
  ['1-5', 'ร้อยละ 0'],
  ['6', 'ร้อยละ 1'],
  ['7', 'ร้อยละ 2'],
  ['8', 'ร้อยละ 3'],
  ['9', 'ร้อยละ 4'],
  ['10', 'ร้อยละ 5'],
  ['11', 'ร้อยละ 6'],
  ['12', 'ร้อยละ 7'],
  ['13', 'ร้อยละ 8'],
  ['14', 'ร้อยละ 9'],
  ['15', 'ร้อยละ 10'],
  ['16', 'ร้อยละ 11'],
  ['17', 'ร้อยละ 12'],
  ['18', 'ร้อยละ 13'],
  ['19', 'ร้อยละ 14'],
  ['20', 'ร้อยละ 15'],
  ['21', 'ร้อยละ 30'],
  ['22', 'ร้อยละ 45'],
  ['23', 'ร้อยละ 55'],
  ['24', 'ร้อยละ 65'],
  ['25', 'ร้อยละ 70'],
]

const dataForDividendTable_3_15_8 = [
  ['1-8', 'ร้อยละ 0'],
  ['9', 'ร้อยละ 20'],
  ['10', 'ร้อยละ 30'],
  ['11', 'ร้อยละ 40'],
  ['12', 'ร้อยละ 50'],
  ['13', 'ร้อยละ 60'],
  ['14', 'ร้อยละ 65'],
  ['15', 'ร้อยละ 70'],
]

const WORDS_BY_TYPE = {
  1: ['ณ สิ้นปีกรมธรรม์ที่ 10', 'ณ สิ้นปีกรมธรรม์ที่ 10', 'ณ สิ้นปีกรมธรรม์ที่ 10', 'ณ สิ้นปีกรมธรรม์ที่ 10', '5%'], //25/5
  2: ['ณ สิ้นปีกรมธรรม์ที่ 15', 'ณ สิ้นปีกรมธรรม์ที่ 15', 'ณ สิ้นปีกรมธรรม์ที่ 15', 'ณ สิ้นปีกรมธรรม์ที่ 15', '10%'], //25/5
  3: ['ณ สิ้นปีกรมธรรม์ที่ 20', 'ณ สิ้นปีกรมธรรม์ที่ 20', 'ณ สิ้นปีกรมธรรม์ที่ 20', 'ณ สิ้นปีกรมธรรม์ที่ 20', '15%'], //25/5
  4: [
    //25/5
    'ณ วันครบกำหนดสัญญา',
    'กรณีครบกำหนดสัญญา',
    'ณ วันครบกำหนดสัญญา',
    'ณ วันครบกำหนดสัญญา',
    '70%',
  ],
  5: [
    //25/5
    'กรณีเสียชีวิต (สมมติฐาน เสียชีวิตในปีกรมธรรม์ที่ 4)',
    'กรณีเสียชีวิต',
    'กรณีเสียชีวิตในปีกรมธรรม์ที่ 4',
    'กรณีเสียชีวิตในปีกรมธรรม์ที่ 4',
    '100%',
  ],
  6: [
    //25/5
    'ที่ผู้เอาประกันภัยขอใช้สิทธิเวนคืนกรมธรรม์ (สมมติฐาน ขอเวนคืนกรมธรรม์ในปีกรมธรรม์ที่ 17)',
    'กรณีเวนคืนกรมธรรม์',
    'กรณีเวนคืนกรมธรรม์ในปีกรมธรรม์ที่ 17',
    'กรณีขอเวนคืนกรมธรรม์ในปีกรมธรรม์ที่ 17',
    '12%',
  ],
  7: [
    //15/8
    'ที่ผู้เอาประกันภัยขอใช้สิทธิเวนคืนกรมธรรม์ (สมมติฐาน เสียชีวิตในปีกรมธรรม์ที่ 7)',
    'กรณีเสียชีวิต',
    'กรณีเสียชีวิตในปีกรมธรรม์ที่ 7',
    'กรณีเสียชีวิตในปีกรมธรรม์ที่ 7',
    '100%',
  ],
  8: [
    //15/8
    'ที่ผู้เอาประกันภัยขอใช้สิทธิเวนคืนกรมธรรม์ (สมมติฐาน ขอเวนคืนกรมธรรม์ในปีกรมธรรม์ที่ 9)',
    'กรณีเวนคืนกรมธรรม์',
    'กรณีเวนคืนกรมธรรม์ในปีกรมธรรม์ที่ 9',
    'กรณีขอเวนคืนกรมธรรม์ในปีกรมธรรม์ที่ 9',
    '20%',
  ],
  9: ['ณ สิ้นปีกรมธรรม์ที่ 10', 'ณ สิ้นปีกรมธรรม์ที่ 10', 'ณ สิ้นปีกรมธรรม์ที่ 10', 'ณ สิ้นปีกรมธรรม์ที่ 10', '30%'], //15/8
  10: [
    //15/8
    'ณ วันครบกำหนดสัญญา',
    'กรณีครบกำหนดสัญญา',
    'ณ วันครบกำหนดสัญญา',
    'ณ วันครบกำหนดสัญญา',
    '70%',
  ],
}

const getFormula = (policyValue, rate, typeNumber) => {
  const rateMap = {
    '-1': 'low',
    '3': 'medium',
    '5': 'high',
  }

  const yearMap = {
    1: 10,
    2: 15,
    3: 20,
    4: 25,
    5: 4,
    6: 17,
    7: 7,
    8: 9,
    9: 10,
    10: 15,
  }

  const level = rateMap[rate]
  const year = yearMap[typeNumber]

  if (!level || !year) return null

  const key = `${level}FormulaYear${year}`
  return policyValue[key] || null
}

const formulaExpression = (policyValue, rate, typeNumber) => {
  const words = WORDS_BY_TYPE[typeNumber] ?? ['', '', '', '']
  const formula = getFormula(policyValue, rate, typeNumber)
  let basicPremium = policyValue.subtotalAnnualBasicPremium
  if (typeNumber === 5) {
    basicPremium = policyValue.cumulativeBasicPremiumWhenDeath_25_5
  } else if (typeNumber === 7) {
    basicPremium = policyValue.cumulativeBasicPremiumWhenDeath_15_8
  }
  return (
    <table className="formula">
      <tr>
        <td className="title">
          ตัวอย่างการคำนวณผลตอบแทนตามดัชนีอ้างอิง <WordWraps>{words[0]}</WordWraps>
        </td>
        <td>
          = จำนวนเบี้ยฯ ที่ชำระมาทั้งหมด X Max ( 0,{' '}
          {fraction('ระดับดัชนีอ้างอิง ณ วันคำนวณมูลค่าวันสุดท้าย', 'ระดับดัชนีอ้างอิง ณ วันคำนวณมูลค่าวันแรก')} - 100%)
          X<br />
          อัตราการมีส่วนร่วมในผลตอบแทนที่เกิดจากการเปลี่ยนแปลงของดัชนี⁽¹⁾ X<br />({' '}
          {fraction('อัตราแลกเปลี่ยน ณ วันคำนวณมูลค่าวันสุดท้าย', 'อัตราแลกเปลี่ยน ณ วันคำนวณมูลค่าวันแรก')} )
        </td>
      </tr>
      <br />
      <tr>
        <td></td>
        <td>
          {MESSAGES.INDEX_LINKED_FORMULA_REMARK[0]}{' '}
          {Mustache.render(MESSAGES.INDEX_LINKED_FORMULA_REMARK[1], {
            word: words[1],
          })}
        </td>
      </tr>
      <tr>
        <td></td>
        <td>
          = {dashedOutOrWithPrecision(basicPremium, 2)} X Max ( 0, {fraction(formula?.index, 100, 4)} - 100%) X 90% X{' '}
          {fraction(35, 35)}
        </td>
      </tr>
      <tr>
        <td></td>
        <td>= {formatNumber(formula?.summaryDividend, 2, true)} บาท</td>
      </tr>
      <tr>
        <td></td>
        <td>
          อัตราการจ่ายผลตอบแทนตามดัชนีอ้างอิง {words[2]} = {words[4]}
        </td>
      </tr>
      <tr>
        <td></td>
        <td>
          = {formatNumber(formula?.summaryDividend, 2, true)} x {words[4]}
        </td>
      </tr>
      <tr>
        <td></td>
        <td>ผลตอบแทนตามดัชนีอ้างอิง {words[3]}</td>
      </tr>
      <tr>
        <td></td>
        <td>= {formatNumber(formula?.summaryDividendWithIndex, 2, true)} บาท</td>
      </tr>
    </table>
  )
}

const dividendTable = (tableHeader, tableData) => (
  <div className="dividend-table">
    <table width="100%">
      <thead>
        <tr>
          <td width="50%">{tableHeader[0]}</td>
          <td width="50%">
            {tableHeader[1].split('\n').map((line, index) => (
              <React.Fragment key={index}>
                {line}
                <br />
              </React.Fragment>
            ))}
          </td>
        </tr>
      </thead>
      <tbody style={{ textAlign: 'center' }}>
        {tableData.map((data) => (
          <tr>
            <td>{data[0]}</td>
            <td>{data[1]}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
)

const renderNotePolicyValueTableForGio = ({ policyValue, basicPlan }, rate, index) => {
  const lastYearEndPolicy = _.get(_.last(policyValue.yearEndPolicyValues), 'yearEndPolicy', 0) + 1
  const dividendValue = policyValue.yearEndPolicyValues[
    policyValue.yearEndPolicyValues.length - 1
  ]?.dividend?.dividendValue.find((value) => value.title === rate.toString())
  const getExampleNumber = {
    '-1': 1,
    3: 2,
    5: 3,
  }
  const getDataByProductCode = () => {
    if (Object.values(VALUES.INDEX_LINKED_25_5_CODE).includes(basicPlan.code)) {
      return [
        MESSAGES.INDEX_LINKED_DISCLAIMER.title_25_5,
        MESSAGES.INDEX_LINKED_DISCLAIMER.note_4_25_5,
        5,
        6,
        dataForDividendTable_2_25_5,
        dataForDividendTable_3_25_5,
        formulaExpression(policyValue, rate, 1),
        4,
      ]
    } else if (Object.values(VALUES.INDEX_LINKED_15_8_CODE).includes(basicPlan.code)) {
      return [
        MESSAGES.INDEX_LINKED_DISCLAIMER.title_15_8,
        MESSAGES.INDEX_LINKED_DISCLAIMER.note_4_15_8,
        7,
        8,
        dataForDividendTable_2_15_8,
        dataForDividendTable_3_15_8,
        formulaExpression(policyValue, rate, 9),
        10,
      ]
    }
    return [
      MESSAGES.INDEX_LINKED_DISCLAIMER.title_25_5,
      MESSAGES.INDEX_LINKED_DISCLAIMER.note_4_25_5,
      5,
      6,
      dataForDividendTable_2_25_5,
      dataForDividendTable_3_25_5,
      formulaExpression(policyValue, rate, 1),
      4,
    ]
  }
  return (
    <div>
      <div className="table-wrap">
        <PolicyValueContent lastYearEndPolicy={lastYearEndPolicy} basicPlan={basicPlan} {...policyValue} rate={rate} />
      </div>
      <div className="disclaimer">
        <div className="title">{getDataByProductCode()[0]}</div>
        {getDataByProductCode()[6]}
        {Object.values(VALUES.INDEX_LINKED_25_5_CODE).includes(basicPlan.code) && (
          <>
            <br />
            {formulaExpression(policyValue, rate, 2)}
            <br />
            {formulaExpression(policyValue, rate, 3)}
          </>
        )}
        <br />
        <p style={{ color: '#000000' }}>{MESSAGES.INDEX_LINKED_FORMULA_REMARK[2]}</p>
        <p>{MESSAGES.INDEX_LINKED_FORMULA_REMARK[3]}</p>
        <p>
          {Mustache.render(MESSAGES.INDEX_LINKED_FORMULA_REMARK[4], {
            rate: rate,
            dividendIndex: getFormula(policyValue, rate, 1)?.index,
            word: WORDS_BY_TYPE[1][0],
          })}
        </p>
        {Object.values(VALUES.INDEX_LINKED_25_5_CODE).includes(basicPlan.code) && (
          <>
            <p>
              {Mustache.render(MESSAGES.INDEX_LINKED_FORMULA_REMARK[4], {
                rate: rate,
                dividendIndex: getFormula(policyValue, rate, 2)?.index,
                word: WORDS_BY_TYPE[2][0],
              })}
            </p>
            <p>
              {Mustache.render(MESSAGES.INDEX_LINKED_FORMULA_REMARK[4], {
                rate: rate,
                dividendIndex: getFormula(policyValue, rate, 3)?.index,
                word: WORDS_BY_TYPE[3][0],
              })}
            </p>
          </>
        )}
        <p>{MESSAGES.INDEX_LINKED_FORMULA_REMARK[5]}</p>
        <p>{MESSAGES.INDEX_LINKED_FORMULA_REMARK[6]}</p>
        <br />
        <div className="title">
          ตัวอย่างการคำนวณผลตอบแทนตามดัชนีอ้างอิง กรณีครบกำหนดสัญญา กรณีเสียชีวิต และกรณีเวนคืนกรมธรรม์
        </div>
        {formulaExpression(policyValue, rate, getDataByProductCode()[7])}
        <br />
        {formulaExpression(policyValue, rate, getDataByProductCode()[2])}
        <br />
        {formulaExpression(policyValue, rate, getDataByProductCode()[3])}
        <br />
        <p style={{ color: '#000000' }}>{MESSAGES.INDEX_LINKED_FORMULA_REMARK[2]}</p>
        <p>{MESSAGES.INDEX_LINKED_FORMULA_REMARK[3]}</p>
        <p>
          {Mustache.render(MESSAGES.INDEX_LINKED_FORMULA_REMARK[4], {
            rate: rate,
            dividendIndex: formatNumber(getFormula(policyValue, rate, getDataByProductCode()[7])?.index, 4),
            word: WORDS_BY_TYPE[4][1],
          })}
        </p>
        <p>
          {Mustache.render(MESSAGES.INDEX_LINKED_FORMULA_REMARK[4], {
            rate: rate,
            dividendIndex: formatNumber(getFormula(policyValue, rate, getDataByProductCode()[2])?.index, 4),
            word: WORDS_BY_TYPE[getDataByProductCode()[2]][3],
          })}
        </p>
        <p>
          {Mustache.render(MESSAGES.INDEX_LINKED_FORMULA_REMARK[4], {
            rate: rate,
            dividendIndex: formatNumber(getFormula(policyValue, rate, getDataByProductCode()[3])?.index, 4),
            word: WORDS_BY_TYPE[getDataByProductCode()[3]][3],
          })}
        </p>
        <p>{MESSAGES.INDEX_LINKED_FORMULA_REMARK[5]}</p>
        <p>{MESSAGES.INDEX_LINKED_FORMULA_REMARK[6]}</p>
        <br />
        <p style={{ color: '#000000' }}>{MESSAGES.NOTE}</p>
        <div id="meh-exception-note32">
          <ol className="list-cell" style={{ marginLeft: '-40px' }}>
            <li style={{ display: 'block' }}>
              <span>(1)</span>
              <span>{MESSAGES.INDEX_LINKED_DISCLAIMER.note_1[0]}</span>
            </li>
            <li style={{ display: 'block' }}>
              <span>(2)</span>
              <span>{MESSAGES.INDEX_LINKED_DISCLAIMER.note_1[1]}</span>
            </li>
            <li style={{ display: 'block' }}>
              <span>(3)</span>
              <span>{MESSAGES.INDEX_LINKED_DISCLAIMER.note_1[2]}</span>
            </li>
            <li style={{ display: 'block' }}>
              <span>(4)</span>
              <span>{MESSAGES.INDEX_LINKED_DISCLAIMER.note_1[3]}</span>
              <ol className="list-cell">
                <li style={{ display: 'block' }}>
                  <span>(4.1)</span>
                  <span>
                    {Object.values(VALUES.INDEX_LINKED_15_8_CODE).includes(basicPlan.code)
                      ? MESSAGES.INDEX_LINKED_DISCLAIMER.note_2_15_8[0]
                      : MESSAGES.INDEX_LINKED_DISCLAIMER.note_2[0]}
                  </span>
                </li>
                {Object.values(VALUES.INDEX_LINKED_25_5_CODE).includes(basicPlan.code) &&
                  dividendTable(MESSAGES.INDEX_LINKED_DISCLAIMER.table_header_1, dataForDividendTable_1)}
                <li style={{ display: 'block' }}>
                  <span>(4.2)</span>
                  <span>{MESSAGES.INDEX_LINKED_DISCLAIMER.note_2[1]}</span>
                </li>
                <li style={{ display: 'block' }}>
                  <span>(4.3)</span>
                  <span>{MESSAGES.INDEX_LINKED_DISCLAIMER.note_2[2]}</span>
                </li>
                {dividendTable(MESSAGES.INDEX_LINKED_DISCLAIMER.table_header_2, getDataByProductCode()[4])}
                <li style={{ display: 'block' }}>
                  <span>(4.4)</span>
                  <span>{MESSAGES.INDEX_LINKED_DISCLAIMER.note_2[3]}</span>
                </li>
                {dividendTable(MESSAGES.INDEX_LINKED_DISCLAIMER.table_header_3, getDataByProductCode()[5])}
              </ol>
            </li>
          </ol>
        </div>
        <p>
          {Mustache.render(MESSAGES.INDEX_LINKED_DISCLAIMER.note_3, {
            rate,
            exampleNumber: getExampleNumber[rate],
          })}
        </p>
        <br />
        <p>{getDataByProductCode()[1]}</p>
      </div>
    </div>
  )
}

export default PolicyValueGioTable
